import React from 'react';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Cache en mémoire uniquement (pas de persistance disque/localStorage) : il
// repart à zéro à chaque rechargement de page, ce qui est voulu — on veut
// juste éviter de refetcher quand l'utilisateur navigue entre les pages de
// l'OAD ou revient sur des paramètres déjà consultés.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Les résultats DiagoRisk ne changent pas pendant une session : inutile
      // de refetcher tant que les paramètres sont identiques.
      staleTime: Infinity,
      gcTime: 30 * 60 * 1000, // 30 min avant purge d'un résultat inutilisé
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
